import React from 'react';
import { Linkedin, Twitter } from 'lucide-react';
import { LogoBot } from '../Logo';

const Footer = () => {
  const footerLinks = {
    product: [
      { label: 'Voice Agents', href: '#solutions' },
      { label: 'Chat Agents', href: '#solutions' },
      { label: 'Website Agents', href: '#solutions' },
      { label: 'Integrations', href: '#integrations' },
      { label: 'Pricing', href: '#pricing' },
    ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Careers', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Contact', href: '#' },
    ],
    resources: [
      { label: 'Documentation', href: '#' },
      { label: 'Help Center', href: '#' },
      { label: 'Case Studies', href: '#use-cases' },
      { label: 'API Reference', href: '#' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Cookie Policy', href: '#' },
    ],
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4">
              <LogoBot size="default" showText={true} />
            </div>
            <p className="text-gray-500 text-sm mb-6">
              Human-like AI agents that sell, support, and book clients for your business.
            </p>
            <nav aria-label="Social media links">
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors"
                  aria-label="Follow us on Twitter"
                >
                  <Twitter size={18} className="text-gray-600" aria-hidden="true" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors"
                  aria-label="Follow us on LinkedIn"
                >
                  <Linkedin size={18} className="text-gray-600" aria-hidden="true" />
                </a>
              </div>
            </nav>
          </div>

          {/* Product Links */}
          <nav aria-label="Product navigation">
            <h4 className="text-gray-900 font-medium mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Company Links */}
          <nav aria-label="Company navigation">
            <h4 className="text-gray-900 font-medium mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Resources Links */}
          <nav aria-label="Resources navigation">
            <h4 className="text-gray-900 font-medium mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Legal Links */}
          <nav aria-label="Legal navigation">
            <h4 className="text-gray-900 font-medium mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} AI AutoBots. All rights reserved.
          </p>
          <address className="flex items-center gap-2 text-gray-500 text-sm not-italic">
            <span>aiautobots.co</span>
          </address>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
